/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import ConfigProvider from '../config-provider';

class StepView extends React.Component {
  render() {
    const { prefix, children } = this.props;
    return (
      <div
        className={`${prefix}step-dialog-view`}
      >
        {children}
      </div>
    );
  }
}

StepView.propTypes = {
  prefix: PropTypes.string,
  id: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  footer: PropTypes.node,
  children: PropTypes.node,
};

StepView.defaultProps = {
  prefix: 'next-',
};

const Configed = ConfigProvider.config(StepView);
Configed.displayName = 'StepView';

export default Configed;
